/* tslint:disable */
/* eslint-disable */

/**
 * Way of calculation GravelAreas
 */
export enum GravelCalcType {
  Average = 'AVERAGE',
  Position = 'POSITION',
  Local = 'LOCAL'
}
